import { Component, ElementRef, OnInit, ViewChild, ChangeDetectionStrategy } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { getDashboardStockChart } from "../api.service";
import { getApp } from "../app";

@Component({
    selector: "app-stock-graphic-modal",
    templateUrl: "./stock-graphic-modal.component.html",
    styleUrls: ["./stock-graphic-modal.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class StockGraphicModalComponent implements OnInit {
  app = getApp((app) => {
    this.app = app;
  });

  @ViewChild("stockGraphicModal", { static: false })
  stockGraphicModal: any;
  @ViewChild("stockChartContainer", { static: false })
  stockChartContainer?: ElementRef<HTMLElement>;

  chartHtml = "";
  noCpn = false;
  noData = false;

  cpn = "";
  mpn = "";

  constructor(private modalService: NgbModal) {}

  ngOnInit() {
    if (
      this.app.thread.thread["thread.artNumber"] != "" &&
      this.app.thread.thread["thread.artNumber"] != null
    ) {
      this.cpn = this.app.thread.thread["thread.artNumber"];
    }
    if (
      this.app.thread.thread["thread.crtNumber"] != "" &&
      this.app.thread.thread["thread.crtNumber"] != null
    ) {
      this.mpn = this.app.thread.thread["thread.crtNumber"];
    }
  }

  async openModal() {
    await this.getData();

    if (this.noCpn || this.noData) {
      this.modalService.open(this.stockGraphicModal, {
        windowClass: "mediumModal",
      });
      return;
    }

    const modalRef = this.modalService.open(this.stockGraphicModal, {
      windowClass: "stockGraphicModal",
    });
    modalRef.shown.subscribe(() => this.renderChart());
  }

  // get stock data for graphic
  async getData() {
    this.chartHtml = "";
    this.noCpn = false;
    this.noData = false;

    const cpn = this.app.thread.thread["thread.artNumber"];
    if (cpn == null || cpn === "") {
      this.noCpn = true;
    } else {
      const chartHtml = await getDashboardStockChart(
        this.app.customers.expectCurrent,
        cpn
      );
      if (chartHtml) {
        this.chartHtml = chartHtml
          .replace(/{{stockDemandLabel}}/g, this.app.text.stock.demand)
          .replace(
            /{{stockLtbInventoryLabel}}/g,
            this.app.text.stock.ltbInventory
          );
      } else {
        this.noData = true;
      }
    }
  }

  private async renderChart() {
    const container = this.stockChartContainer?.nativeElement;
    if (!container || !this.chartHtml) {
      return;
    }

    container.innerHTML = this.chartHtml;
    const scripts = Array.from(container.querySelectorAll("script"));
    scripts.forEach((script) => script.remove());

    for (const oldScript of scripts.filter((script) => script.src)) {
      if (document.querySelector(`script[src="${oldScript.src}"]`)) {
        continue;
      }

      await new Promise<void>((resolve) => {
        const script = document.createElement("script");
        script.src = oldScript.src;
        script.onload = () => resolve();
        script.onerror = () => resolve();
        document.body.appendChild(script);
      });
    }

    scripts
      .filter((script) => !script.src && script.textContent)
      .forEach((script) => {
        try {
          new Function(script.textContent ?? "")();
        } catch (error) {
          console.error("Error executing stock chart script:", error);
        }
      });
  }

  closeModal() {
    this.modalService.dismissAll();
  }
}
